import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// assignedApiSlice.js
export const fetchCompanyAssignedApis = createAsyncThunk(
  "assignedApis/fetchList",
  async (superAdminId, { rejectWithValue }) => {
    try {
      const res = await axios.get("https://payyug.in/api/company-api-assign/list", {
        params: {
          limit: 100000,
          page: 1,
          superAdminId: superAdminId || undefined,
        },
      });

      const data = res?.data?.data || res?.data || [];
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("API Error in Thunk:", error);
      return rejectWithValue(error.response?.data || "Error fetching data");
    }
  }
);

const assignedApiSlice = createSlice({
  name: "assignedApis",
  initialState: {
    assignedApis: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyAssignedApis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyAssignedApis.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedApis = action.payload;
      })
      .addCase(fetchCompanyAssignedApis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default assignedApiSlice.reducer;